// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"5589":"newdetail-fpReady","6496":"newdetail-scoll"}[chunkId] + "." + {"5589":"8e0d052f","6496":"5b490e26"}[chunkId] + ".css";
};